/**
 * Cart bridge — uses a third-party cart app when present, otherwise Dawn drawer.
 */
(function () {
  const APP_CART_SELECTORS = [
    '#slidecarthq',
    '#upcart',
    '#monster-cart-upsell-cart',
    '[data-app-cart]',
    'rebuy-cart',
    '.rebuy-cart',
    'shopify-cart-slideout',
    '#cart-drawer-app',
  ];

  function getAppCartElement() {
    for (const selector of APP_CART_SELECTORS) {
      const el = document.querySelector(selector);
      if (el) return el;
    }
    return null;
  }

  function getAppCartApi() {
    return window.Rebuy?.Cart || window.SlideCart || window.upcart || window.monsterCart || null;
  }

  function openAppCart() {
    const api = getAppCartApi();
    if (api) {
      if (typeof api.open === 'function') api.open();
      else if (typeof api.show === 'function') api.show();
      else if (typeof api.toggle === 'function') api.toggle();
      return true;
    }

    const el = getAppCartElement();
    if (!el) return false;

    el.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    el.classList.add('is-open', 'active', 'open');
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('slidecart:open'));
    return true;
  }

  function hasAppCart() {
    return !!(getAppCartElement() || getAppCartApi());
  }

  function openNativeCart() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    window.location.href = window.routes?.cart_url || '/cart';
    return false;
  }

  function handleCartUpdate(event) {
    if (!event || event.source !== 'product-form') return;

    if (hasAppCart()) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer?.classList.contains('active') && typeof drawer.close === 'function') {
        drawer.close();
      }
      setTimeout(openAppCart, 80);
      return;
    }

    const drawer = document.querySelector('cart-drawer');
    if (drawer && !drawer.classList.contains('active') && typeof drawer.open === 'function') {
      setTimeout(() => drawer.open(), 80);
    }
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
    }

    document.addEventListener('cart:refresh', openAppCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.CoCart = { openAppCart, openNativeCart, hasAppCart };
})();
